module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/arrow/light/long-up-cbc364be4d6c883f14dec07805657552.png";